// Module
var code = "<div id=\"V-3AD188FA-8B88-4439-8310-4C46E184962A\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding decoratorComponent}\" class=\"stretch-content\"> </div> </div> ";
// Exports
export default code;